import Image from "next/image";
import React from "react";
// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/navigation";
// import "swiper/css/thumbs";
import logos from "../../../assets/images/logos.png";
import prodd1 from "../../../assets/images/prodd1.png";
import prodd2 from "../../../assets/images/prodd2.png";
import prodd3 from "../../../assets/images/prodd3.png";
import prodd4 from "../../../assets/images/prodd4.png";
import prodd5 from "../../../assets/images/prodd5.png";
import prodd6 from "../../../assets/images/prodd6.png";
import prodd7 from "../../../assets/images/prodd7.png";
import prodd8 from "../../../assets/images/prodd8.png";
import styles from "./certificate.module.scss";

const ProductDetailsCertificate = () => {
  return (
    <>
      {/* <div className={styles.border_t_b}>
        <div className="row">
          <div className="col-md-6">
            <p className={styles.certificate}>CERTIFICATE OF AUTHENTICITY</p>
            <p>
              Every piece of jewellery that we make is certified for
              authenticity by third-party international laboratories like SGL,
              IGI, BIS and GIA.
            </p>
          </div>
          <div className="col-md-6">
            <Image src={logos} alt="" />
          </div>
        </div>
      </div> */}
      <div className={styles.certificate_container}>
        <div className={styles.heading}>With Every Product You Buy You Get</div>
        <div className="row">
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd1} alt="" />
              </figure>
              <p>Senco Five-Star Promise</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd2} alt="" />
              </figure>
              <p>Zero Deduction Gold Exchange</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd3} alt="" />
              </figure>
              <p>Easy Exchange</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd4} alt="" />
              </figure>
              <p>Assured Lifetime Maintenance</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd5} alt="" />
              </figure>
              <p>Tested & Certified Diamonds</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd6} alt="" />
              </figure>
              <p>BIS Hallmarked Pure Gold</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd7} alt="" />
              </figure>
              <p>Guaranteed Buyback</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className={styles.icon_card}>
              <figure>
                <Image src={prodd8} alt="" />
              </figure>
              <p>7 Days Return Policy</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetailsCertificate;
